@for (classification of filteredClassifications; track classification) {
	<div class="classification-badge" [matTooltip]="classification.name">
		{{ classification.name }}
	</div>
}

@if (!filteredClassifications?.length) {
	<div class="no-data"></div>
}
